import {
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { Observable, catchError, last, of, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AlertService } from '../services/alert.service';
import { AuthGuardService } from '../services/auth/auth-guard.service';
import { SpinnerService } from '../services/spinner.service';
import { StorageService } from '../services/storage.service';
import { DocumentService } from '../services/document.service';
import { PlatformService } from '../services/platform.service';
import { CacheService } from '../services/cach.service';
var requestFileService: any = undefined;
@Injectable({ providedIn: 'root' })
export class InterceptorService implements HttpInterceptor {
  //Requests Stack To Show Spinner After First Request Created And Hide After Last Request Finished
  stack: number[] = [];
  visitorId?: string;
  stopChangeI18n = false;
  constructor(
    private spinner: SpinnerService,
    public alert: AlertService,
    private pt: PlatformService,
    private storage: StorageService,
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let params: HttpParams = req.params;
    if (
      req.url.includes(environment.front.host) ||
      req.url.includes('assets/media') ||
      req.url.includes('.js') ||
      req.url.includes('.css') ||
      (req.url.includes('.json') && req.url.includes(environment.back.i18n) && environment.production)
    ) {
      //Load File From Server In SSR Mode
      if (this.pt.isServer) {
        try {
          if (!requestFileService) {

            requestFileService = require('../services/request-file.servie.ts')
          }

          var content = requestFileService?.default.getFile(req.url);
          return of(new HttpResponse({ status: 200, body: content }));
        } catch (error) {
          console.log('load from server', error);
        }
      } return next.handle(req.clone({ params: params }));
    }


    let apiReq = req.clone({ params: params });
    if (req.url.includes('http')) {
      return this.handelError(apiReq, next);
    }

    let headers = req.headers;

    if (this.storage.userAuth.isHasValue) {
      headers = headers.set(
        'Authorization',
        `Bearer ${this.storage.userAuth.value}`,
      );
    }

    headers = headers.set('Accept-Language', this.storage.i18n.value);
    if (this.visitorId) headers = headers.set('visitor-id', this.visitorId);

    apiReq = req.clone({
      url: `${environment.back.apiBaseUrl}${req.url}`,
      // body:JSON.stringify(req.body),
      params: params,
      headers: headers,
    });

    return this.handelError(apiReq, next);
  }

  handelError(req: HttpRequest<any>, next: HttpHandler) {
    let isSilent = false;

    if (
      req.params.get('isSilent') === undefined &&
      req.body?.isSilent === undefined
    ) {
      isSilent = req.method == 'GET' ? false : true;
    } else {
      isSilent =
        req.params.get('isSilent') == 'true' || req.body?.isSilent
          ? true
          : false;
    }
    //console.log('isSilent', isSilent, req.url);

    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.Sent:
            {
              if (!isSilent) {
                if (!this.stack.length) this.spinner?.show();
                this.stack.push(1);
              }
            }
            break;
          case HttpEventType.UploadProgress:
            {
              this.spinner.updateTitle('Uploading');
              AlertService;
              this.spinner.progressPercent.next(
                Math.round((100 / (event.total || 0)) * event.loaded),
              );
            }
            break;
          case HttpEventType.Response:
            {
              this.visitorId =
                event.headers.get('visitor-id') || this.visitorId;
              this.stack.shift();
              if (!this.stack.length) {
                this.spinner?.hide();
                this.spinner.progressPercent.next(0);
              }
            }
            break;
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.stack.shift();
        if (!this.stack.length) {
          this.spinner?.hide();
          this.spinner.progressPercent.next(0);
        }

        if (!req.params.get('isSilent')) {
          if (error.status == 0) {
            this.alert.error(
              "I can't reach the server, or something went wrong",
            );
          } else if (error.status == 401) {
            this.alert.catchError(error);
            Inject(AuthGuardService).auth.logout('/');
          } else {
            if (!req.params.get('isSilent') && !req.body?.isSilent)
              this.alert.catchError(error);
          }
        }
        return throwError(error);
      }),
    );
  }
}
